import { createContext, ReactNode } from 'react';

import { MobileHeaderCardContextValue } from './interfaces';

export const MobileHeaderCardContext =
  createContext<Nullable<MobileHeaderCardContextValue>>(null);

export const MobileHeaderCardProvider = ({
  children,
  value,
}: {
  children?: ReactNode;
  value: MobileHeaderCardContextValue;
}) => {
  return (
    <MobileHeaderCardContext.Provider value={value}>
      {children}
    </MobileHeaderCardContext.Provider>
  );
};
